import { render } from "./AddOffering.vue?vue&type=template&id=e88f70aa&scoped=true"
import script from "./AddOffering.vue?vue&type=script&lang=js"
export * from "./AddOffering.vue?vue&type=script&lang=js"

import "./AddOffering.vue?vue&type=style&index=0&id=e88f70aa&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e88f70aa"]])

export default __exports__